import React, { useState, useEffect } from "react";
import Skeleton from "react-loading-skeleton";
import { Table, Button } from "antd";
import ApiService from "../util/ApiService";
import CustomPagination from "../util/CustomPagination";
import { ExclamationCircleOutlined, EditOutlined } from "@ant-design/icons";
import PlantaoModal from "../dashboard/calender/plantaoModal";
import ScaleModal from "../dashboard/calender/dutyDetailModal";
import DutyModal from "../dashboard/calender/plantaoModal";

const PendingConflict = ({ companyId }) => {
    const [conflictData, setConflictData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);

    const [pagination, setPagination] = useState({current: 1, pageSize: 10, total: 0, lastPage: 0});
    const [showEventModal, setShowEventModal] = useState(false);
    const [showPlantaoModal, setShowPlantaoModal] = useState(false);

    const [showScaleModal, setShowScaleModal] = useState(false);
    const [showDutyModal, setShowDutyModal] = useState(false);
    const fetchConflicts = async (page = 1, limit = 10) => {
        try {
            setLoading(true);
            const response = await ApiService.send("get", `${process.env.REACT_APP_URL_API}scale/conflict?page=${page}&pagination=${limit}`, {}, true);

            const {data, pagination: pagInfo} = ApiService.handleApiResponse(response);
            setConflictData(data || []);
            setPagination(pagInfo || {current: 1, pageSize: 10, total: 0});


        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false);
        }
    };



    const handleScaleModalClose = () => {
        setShowScaleModal(false);
    };

    const handleDutyModalClose = () => {
        setShowDutyModal(false);
    };



    useEffect(() => {
        fetchConflicts(page, limit);
    }, [page, limit]);

    const conflictColumns = [
        {
            title: "Usuário",
            dataIndex: "users_name",
            key: "users_name",
        },
        {
            title: "Hospital",
            key: "hospital_info",
            render: (record) => (
                <div>
                    <strong>{record.hospitals_name_1}</strong>
                    <br/>
                    <span style={{fontSize: "0.8em", color: "#666"}}>
                        {record.hospitals_city_name_1} - {record.hospitals_uf_1}
                    </span>
                    <br/><br/>
                    <span>
                         <i className="fa fa-clock"></i> {new Date(record.start_time_1).toLocaleString()}</span>
                    <br/>
                    <span>
                       <i className="fa fa-clock"></i> {new Date(record.end_time_1).toLocaleString()}
                    </span>
                </div>
            )
        },
        {
            title: "Conflito",
            key: "time_info",
            render: (record) => (
                <div>
                    <strong>
                        {record.hospitals_name_2}
                    </strong>
                    <br/>
                    <span style={{fontSize: "0.8em", color: "#666"}}>
                        {record.hospitals_city_name_2} - {record.hospitals_uf_2}
                    </span>
                    <br/><br/>
                    <span>
                         <i className="fa fa-clock"></i> {new Date(record.start_time_2).toLocaleString()}</span>
                    <br/>
                    <span>
                          <i className="fa fa-clock"></i> {new Date(record.end_time_2).toLocaleString()}
                    </span>
                </div>
            )
        }
    ];

    return (
        <div className="col-12 col-md-12 col-lg-12 mb-4">
            <div className="card h-100 p-3">
                <div className="header-section">
                    <h6 className="card-title"><ExclamationCircleOutlined/> Pendências de Conflito</h6>
                </div>
                <div className="card-body">
                    {loading ? (
                        <Skeleton width="100%" height={150} />
                        ) : conflictData.length > 0 ? (
                            <>
                                <Table
                                    dataSource={conflictData}
                                    columns={conflictColumns}
                                    pagination={false}
                                    rowKey={(record) => `${record.user_id}-${record.start_time_1}`}
                                    style={{ backgroundColor: "#f0f5ff", borderRadius: "5px" }}
                                    rowClassName={(record, index) => (index % 2 === 0 ? "table-row-light" : "table-row-dark")}
                                />
                                <CustomPagination
                                    pagination={pagination}
                                    onChange={(page) => setPage(page)}
                                />
                            </>
                        ) : (
                            <p>Sem conflitos encontrados.</p>
                        )}
                </div>
            </div>
            {showScaleModal && (
                <ScaleModal
                    show={showScaleModal}
                    handleClose={handleScaleModalClose}
                    handleSubmit={() => {
                        setShowScaleModal(false);
                    }}
                />
            )}

            {/* Modal de Plantão */}
            {showDutyModal && (
                <DutyModal
                    show={showDutyModal}
                    handleClose={handleDutyModalClose}
                    handleSubmit={() => {
                        setShowDutyModal(false);
                    }}
                />
            )}
        </div>
    );
};

export default PendingConflict;
